module.exports = __webpack_public_path__ + "static/img/bg47.8ffd710e.png";